interface AppCostsCostList {
  [key: string]: number[];
}
// ----------------------------------------------------------------------
export const _app_costs_cost_list: AppCostsCostList = {
  'Allscripts - Pro (Ephrata)_0': [450000, 81000, 108000, 216000, 54000, 0, 49500, 0],
  'Allscripts - Pro (Ephrata)_1': [459000, 82620, 110160, 220320, 55080, 0, 50490, 0],
  'Allscripts - Pro (Ephrata)_2': [468180, 84272, 112363, 224726, 56182, 85000, 51500, 0],
  'Allscripts - Pro (Ephrata)_3': [477544, 85958, 114610, 229221, 57305, 0, 52530, 0],
  'Allscripts - Pro (Ephrata)_4': [487094, 87677, 116903, 233805, 58451, 0, 53580, 0],
  'Allscripts - Pro (Ephrata)_5': [496836, 89431, 119241, 238481, 59620, 100000, 54652, 0],
  'Allscripts - Pro (Ephrata)_6': [506773, 91219, 121626, 243251, 60813, 0, 55745, 0],
  'Allscripts - Pro (Ephrata)_7': [516909, 93044, 124058, 248116, 62029, 0, 56860, 0],
  'Allscripts - Pro (Ephrata)_8': [527247, 94904, 126539, 253078, 63270, 110000, 57997, 0],
  'Allscripts - Pro (Ephrata)_9': [537792, 96802, 129070, 258140, 64535, 0, 59157, 0],
  'Allscripts - Pro (Gettysburg)_0': [320000, 57600, 76800, 153600, 38400, 0, 35200, 0],
  'Allscripts - Pro (Gettysburg)_1': [326400, 58752, 78336, 156672, 39168, 0, 35904, 0],
  'Allscripts - Pro (Gettysburg)_2': [332928, 59927, 79903, 159805, 39951, 44000, 36622, 0],
  'Allscripts - Pro (Gettysburg)_3': [339587, 61126, 81501, 163002, 40750, 0, 37355, 0],
  'Allscripts - Pro (Gettysburg)_4': [346378, 62348, 83131, 166262, 41565, 0, 38102, 0],
  'Allscripts - Pro (Gettysburg)_5': [353306, 63595, 84793, 169587, 42397, 65000, 38864, 0],
  'Allscripts - Pro (Gettysburg)_6': [360372, 64867, 86489, 172979, 43245, 0, 39641, 0],
  'Allscripts - Pro (Gettysburg)_7': [367579, 66164, 88219, 176438, 44110, 0, 40434, 0],
  'Allscripts - Pro (Gettysburg)_8': [374931, 67488, 89983, 179967, 44992, 100000, 41242, 0],
  'Allscripts - Pro (Gettysburg)_9': [382430, 68837, 91783, 183566, 45892, 0, 42067, 0],
  'Allscripts - Touchworks_0': [975000, 175500, 234000, 468000, 117000, 0, 107250, 0],
  'Allscripts - Touchworks_1': [994500, 179010, 238680, 477360, 119340, 650000, 109395, 150000],
  'Allscripts - Touchworks_2': [1014390, 182590, 243454, 486907, 121727, 0, 111583, 0],
  'Allscripts - Touchworks_3': [1034678, 186242, 248323, 496645, 124161, 0, 113815, 0],
  'Allscripts - Touchworks_4': [1055371, 189967, 253289, 506578, 126645, 0, 116091, 0],
  'Allscripts - Touchworks_5': [1076479, 193766, 258355, 516710, 129177, 0, 118413, 0],
  'Allscripts - Touchworks_6': [1098008, 197642, 263522, 527044, 131761, 874000, 120781, 200000],
  'Allscripts - Touchworks_7': [1119969, 201594, 268792, 537585, 134396, 0, 123197, 0],
  'Allscripts - Touchworks_8': [1142368, 205626, 274168, 548337, 137084, 0, 125660, 0],
  'Allscripts - Touchworks_9': [1165215, 209739, 279652, 559303, 139826, 0, 128174, 0],
  'AthenaHealth EHR- Ephrata_0': [420000, 75600, 100800, 201600, 50400, 0, 46200, 140000],
  'AthenaHealth EHR- Ephrata_1': [428400, 77112, 102816, 205632, 51408, 0, 47124, 140000],
  'AthenaHealth EHR- Ephrata_2': [436968, 78654, 104872, 209745, 52436, 0, 48066, 140000],
  'AthenaHealth EHR- Ephrata_3': [445707, 80227, 106970, 213940, 53485, 0, 49028, 140000],
  'AthenaHealth EHR- Ephrata_4': [454622, 81832, 109109, 218218, 54555, 0, 50008, 140000],
  'AthenaHealth EHR- Ephrata_5': [463714, 83469, 111291, 222583, 55646, 0, 51009, 140000],
  'AthenaHealth EHR- Ephrata_6': [472988, 85138, 113517, 227034, 56759, 0, 52029, 140000],
  'AthenaHealth EHR- Ephrata_7': [482448, 86841, 115788, 231575, 57894, 0, 53069, 140000],
  'AthenaHealth EHR- Ephrata_8': [492097, 88577, 118103, 236207, 59052, 0, 54131, 140000],
  'AthenaHealth EHR- Ephrata_9': [501939, 90349, 120465, 240931, 60233, 0, 55213, 140000],
  'AthenaHealth EHR- York_0': [290000, 52200, 69600, 139200, 34800, 0, 31900, 66000],
  'AthenaHealth EHR- York_1': [295800, 53244, 70992, 141984, 35496, 0, 32538, 66000],
  'AthenaHealth EHR- York_2': [301716, 54309, 72412, 144824, 36206, 0, 33189, 66000],
  'AthenaHealth EHR- York_3': [307750, 55395, 73860, 147720, 36930, 0, 33853, 66000],
  'AthenaHealth EHR- York_4': [313905, 56503, 75337, 150675, 37669, 0, 34530, 66000],
  'AthenaHealth EHR- York_5': [320183, 57633, 76844, 153688, 38422, 0, 35220, 66000],
  'AthenaHealth EHR- York_6': [326587, 58786, 78381, 156762, 39190, 0, 35925, 66000],
  'AthenaHealth EHR- York_7': [333119, 59961, 79949, 159897, 39974, 0, 36643, 66000],
  'AthenaHealth EHR- York_8': [339781, 61161, 81547, 163095, 40774, 0, 37376, 66000],
  'AthenaHealth EHR- York_9': [346577, 62384, 83178, 166357, 41589, 0, 38123, 66000],
  'Cerner (Ephrata)_0': [1500000, 270000, 360000, 720000, 180000, 0, 165000, 140000],
  'Cerner (Ephrata)_1': [1530000, 275400, 367200, 734400, 183600, 0, 168300, 140000],
  'Cerner (Ephrata)_2': [1560600, 280908, 374544, 749088, 187272, 0, 171666, 140000],
  'Cerner (Ephrata)_3': [1591812, 286526, 382035, 764070, 191017, 0, 175099, 140000],
  'Cerner (Ephrata)_4': [1623648, 292257, 389676, 779351, 194838, 0, 178601, 140000],
  'Cerner (Ephrata)_5': [1656121, 298102, 397469, 794938, 198735, 0, 182173, 140000],
  'Cerner (Ephrata)_6': [1689244, 304064, 405418, 810837, 202709, 0, 185817, 140000],
  'Cerner (Ephrata)_7': [1723029, 310145, 413527, 827054, 206763, 0, 189533, 140000],
  'Cerner (Ephrata)_8': [1757489, 316348, 421797, 843595, 210899, 0, 193324, 140000],
  'Cerner (Ephrata)_9': [1792639, 322675, 430233, 860467, 215117, 0, 197190, 140000],
  'Cerner-1 (Main)_0': [927300, 166914, 222552, 445104, 111276, 0, 102003, 300000],
  'Cerner-1 (Main)_1': [945846, 170252, 227003, 454006, 113502, 0, 104043, 300000],
  'Cerner-1 (Main)_2': [964763, 173657, 231543, 463086, 115772, 0, 106124, 300000],
  'Cerner-1 (Main)_3': [984058, 177130, 236174, 472348, 118087, 0, 108246, 300000],
  'Cerner-1 (Main)_4': [1003739, 180673, 240897, 481795, 120449, 0, 110411, 300000],
  'Cerner-1 (Main)_5': [1023814, 184287, 245715, 491431, 122858, 0, 112620, 300000],
  'Cerner-1 (Main)_6': [1044290, 187972, 250630, 501259, 125315, 0, 114872, 300000],
  'Cerner-1 (Main)_7': [1065176, 191732, 255642, 511285, 127821, 0, 117169, 300000],
  'Cerner-1 (Main)_8': [1086480, 195566, 260755, 521510, 130378, 0, 119513, 300000],
  'Cerner-1 (Main)_9': [1108209, 199478, 265970, 531940, 132985, 0, 121903, 300000],
  DrChrono_0: [85000, 15300, 20400, 40800, 10200, 0, 9350, 0],
  DrChrono_1: [86700, 15606, 20808, 41616, 10404, 150000, 9537, 0],
  DrChrono_2: [88434, 15918, 21224, 42448, 10612, 0, 9728, 0],
  DrChrono_3: [90203, 16236, 21649, 43297, 10824, 0, 9922, 0],
  DrChrono_4: [92007, 16561, 22082, 44163, 11041, 0, 10121, 0],
  DrChrono_5: [93847, 16892, 22523, 45046, 11262, 200000, 10323, 0],
  DrChrono_6: [95724, 17230, 22974, 45947, 11487, 0, 10530, 0],
  DrChrono_7: [97638, 17575, 23433, 46866, 11717, 0, 10740, 0],
  DrChrono_8: [99591, 17926, 23902, 47804, 11951, 0, 10955, 0],
  DrChrono_9: [101583, 18285, 24380, 48760, 12190, 220000, 11174, 0],
  'EClinicalWorks - 1_0': [275000, 49500, 66000, 132000, 33000, 220000, 30250, 55000],
  'EClinicalWorks - 1_1': [280500, 50490, 67320, 134640, 33660, 0, 30855, 55000],
  'EClinicalWorks - 1_2': [286110, 51500, 68666, 137333, 34333, 0, 31472, 55000],
  'EClinicalWorks - 1_3': [291832, 52530, 70040, 140079, 35020, 0, 32102, 55000],
  'EClinicalWorks - 1_4': [297669, 53580, 71441, 142881, 35720, 250000, 32744, 55000],
  'EClinicalWorks - 1_5': [303622, 54652, 72869, 145739, 36435, 0, 33398, 55000],
  'EClinicalWorks - 1_6': [309695, 55745, 74327, 148653, 37163, 0, 34066, 55000],
  'EClinicalWorks - 1_7': [315889, 56860, 75813, 151627, 37907, 0, 34748, 55000],
  'EClinicalWorks - 1_8': [322206, 57997, 77330, 154659, 38665, 0, 35443, 55000],
  'EClinicalWorks - 1_9': [328650, 59157, 78876, 157752, 39438, 280000, 36152, 55000],
  'EClinicalWorks - 2_0': [265000, 47700, 63600, 127200, 31800, 0, 29150, 0],
  'EClinicalWorks - 2_1': [270300, 48654, 64872, 129744, 32436, 150000, 29733, 45000],
  'EClinicalWorks - 2_2': [275706, 49627, 66169, 132339, 33085, 0, 30328, 0],
  'EClinicalWorks - 2_3': [281220, 50620, 67493, 134986, 33746, 0, 30934, 0],
  'EClinicalWorks - 2_4': [286845, 51632, 68843, 137685, 34421, 0, 31553, 0],
  'EClinicalWorks - 2_5': [292581, 52665, 70220, 140439, 35110, 160000, 32184, 45000],
  'EClinicalWorks - 2_6': [298433, 53718, 71624, 143248, 35812, 0, 32828, 0],
  'EClinicalWorks - 2_7': [304402, 54792, 73056, 146113, 36528, 0, 33484, 0],
  'EClinicalWorks - 2_8': [310490, 55888, 74518, 149035, 37259, 0, 34154, 0],
  'EClinicalWorks - 2_9': [316700, 57006, 76008, 152016, 38004, 170000, 34837, 50000],
  GEMMS_0: [35000, 6300, 8400, 16800, 4200, 0, 3850, 45000],
  GEMMS_1: [35700, 6426, 8568, 17136, 4284, 0, 3927, 50000],
  GEMMS_2: [36414, 6555, 8739, 17479, 4370, 0, 4006, 55000],
  GEMMS_3: [37142, 6686, 8914, 17828, 4457, 0, 4086, 60000],
  GEMMS_4: [37885, 6819, 9092, 18185, 4546, 0, 4167, 65000],
  GEMMS_5: [38643, 6956, 9274, 18549, 4637, 0, 4251, 70000],
  GEMMS_6: [39416, 7095, 9460, 18920, 4730, 0, 4336, 75000],
  GEMMS_7: [40204, 7237, 9649, 19298, 4824, 0, 4422, 80000],
  GEMMS_8: [41008, 7381, 9842, 19684, 4921, 0, 4511, 85000],
  GEMMS_9: [41828, 7529, 10039, 20078, 5019, 0, 4601, 90000],
  'NextGen - 2_0': [273000, 49140, 65520, 131040, 32760, 0, 30030, 0],
  'NextGen - 2_1': [278460, 50123, 66830, 133661, 33415, 120000, 30631, 75000],
  'NextGen - 2_2': [284029, 51125, 68167, 136334, 34084, 0, 31243, 0],
  'NextGen - 2_3': [289710, 52148, 69530, 139061, 34765, 0, 31868, 0],
  'NextGen - 2_4': [295504, 53191, 70921, 141842, 35460, 0, 32505, 0],
  'NextGen - 2_5': [301414, 54255, 72339, 144679, 36170, 130000, 33156, 85000],
  'NextGen - 2_6': [307442, 55340, 73786, 147572, 36893, 0, 33819, 0],
  'NextGen - 2_7': [313591, 56446, 75262, 150524, 37631, 0, 34495, 0],
  'NextGen - 2_8': [319863, 57575, 76767, 153534, 38384, 0, 35185, 0],
  'NextGen - 2_9': [326260, 58727, 78302, 156605, 39151, 150000, 35889, 100000],
  'NextGen -1_0': [250000, 45000, 60000, 120000, 30000, 0, 27500, 45000],
  'NextGen -1_1': [255000, 45900, 61200, 122400, 30600, 0, 28050, 50000],
  'NextGen -1_2': [260100, 46818, 62424, 124848, 31212, 0, 28611, 55000],
  'NextGen -1_3': [265302, 47754, 63672, 127345, 31836, 0, 29183, 60000],
  'NextGen -1_4': [270608, 48709, 64946, 129892, 32473, 0, 29767, 65000],
  'NextGen -1_5': [276020, 49684, 66245, 132490, 33122, 0, 30362, 70000],
  'NextGen -1_6': [281541, 50677, 67570, 135139, 33785, 0, 30969, 75000],
  'NextGen -1_7': [287171, 51691, 68921, 137842, 34461, 0, 31589, 80000],
  'NextGen -1_8': [292915, 52725, 70300, 140599, 35150, 0, 32221, 85000],
  'NextGen -1_9': [298773, 53779, 71706, 143411, 35853, 0, 32865, 90000],
  'Practice Fusion_0': [165000, 29700, 39600, 79200, 19800, 0, 18150, 25000],
  'Practice Fusion_1': [168300, 30294, 40392, 80784, 20196, 100000, 18513, 25000],
  'Practice Fusion_2': [171666, 30900, 41200, 82400, 20600, 0, 18883, 25000],
  'Practice Fusion_3': [175099, 31518, 42024, 84048, 21012, 0, 19261, 25000],
  'Practice Fusion_4': [178601, 32148, 42864, 85729, 21432, 0, 19646, 25000],
  'Practice Fusion_5': [182173, 32791, 43722, 87443, 21861, 110000, 20039, 25000],
  'Practice Fusion_6': [185817, 33447, 44596, 89192, 22298, 0, 20440, 25000],
  'Practice Fusion_7': [189533, 34116, 45488, 90976, 22744, 0, 20849, 25000],
  'Practice Fusion_8': [193324, 34798, 46398, 92795, 23199, 0, 21266, 25000],
  'Practice Fusion_9': [197190, 35494, 47326, 94651, 23663, 120000, 21691, 25000],
  'Prime Suite_0': [75000, 13500, 18000, 36000, 9000, 220000, 8250, 55000],
  'Prime Suite_1': [76500, 13770, 18360, 36720, 9180, 0, 8415, 55000],
  'Prime Suite_2': [78030, 14045, 18727, 37454, 9364, 0, 8583, 55000],
  'Prime Suite_3': [79591, 14326, 19102, 38203, 9551, 0, 8755, 55000],
  'Prime Suite_4': [81182, 14613, 19484, 38968, 9742, 250000, 8930, 55000],
  'Prime Suite_5': [82806, 14905, 19873, 39747, 9937, 0, 9109, 55000],
  'Prime Suite_6': [84462, 15203, 20271, 40542, 10135, 0, 9291, 55000],
  'Prime Suite_7': [86151, 15507, 20676, 41353, 10338, 0, 9477, 55000],
  'Prime Suite_8': [87874, 15817, 21090, 42180, 10545, 0, 9666, 55000],
  'Prime Suite_9': [89632, 16134, 21512, 43023, 10756, 280000, 9860, 55000],
};
